export default __webpack_public_path__ + "static/media/Legguards of Clarity.33841e97.jpg";